import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { EditProductionProcessSheet } from '../-components/EditProductionProcessSheet';
import { ProductionProcessesTable } from '../-components/ProductionProcessesTable';
import { useEditProductionProcess } from '../-hooks/useEditProductionProcess';
import { productionProcessesQueryOptions } from '../-hooks/useProductionProcesses';
import { useProductionProcessesPage } from '../-hooks/useProductionProcessesPage';

export const Route = createFileRoute(
  '/management/production-processes/(pages)/',
)({
  // The list is fetched whole, so a single warm-the-cache prefetch is all the
  // loader needs — no search params to read.
  // The rejection is swallowed on purpose. The loader is a prefetch — its only
  // job is to have the list already warm when the component mounts. Letting it
  // reject hands the route to the router's error boundary, which replaces the
  // whole page; the table's own "Could not load…" banner then never renders,
  // and that banner is what stops a failed load from reading as an empty
  // system. The component's `useQuery` hits the same failure and surfaces it
  // inline. Verified by the Playwright spec, which asserts the banner.
  loader: () =>
    queryClient
      .ensureQueryData(productionProcessesQueryOptions())
      .catch(() => undefined),
  component: ProductionProcessesPage,
});

function ProductionProcessesPage() {
  const page = useProductionProcessesPage();
  const editor = useEditProductionProcess(page.editId);

  return (
    <PageContainer>
      <ProductionProcessesTable page={page} />

      <EditProductionProcessSheet
        open={page.editId !== null}
        onOpenChange={open => !open && page.closeEdit()}
        editor={editor}
      />
    </PageContainer>
  );
}
